import type { SiteCode } from '@olxpwa-lib/i18n/types';
import { createContext } from 'react';
import type { PrefetchedQueries } from '~api/apollo/types';
import type {
  AppEnvironment,
  ApiEnv,
  Platform,
  LoggedUser,
  TrackEventFn,
  TrackPageViewFn,
  SetTouchPointPageFn,
  GetPreviousTouchPointPageFn,
  AuthContext,
} from '~types';
import type { PathBuilder } from './types';

export type HostPropsContextValue = {
  basename?: string;
  env: AppEnvironment;
  authContext: AuthContext;
  apiEnv: ApiEnv;
  platform: Platform;
  featureFlags: Array<string>;
  jsonFeatureFlags: Record<string, unknown>;
  user: LoggedUser;
  trackEvent: TrackEventFn;
  trackPageView: TrackPageViewFn;
  setTouchPointPage: SetTouchPointPageFn;
  getPreviousTouchPointPage: GetPreviousTouchPointPageFn;
  pathBuilder: PathBuilder.HostProp;
  getAuthToken: () => Promise<string | null>;
  onNotFound: () => void;
  restAPIBaseURL: string;
  siteCode: SiteCode;
  discardTrialEntrypoint: () => void;
  prefetchedQueries?: PrefetchedQueries;
};

export const HostPropsContext = createContext<HostPropsContextValue | undefined>(undefined);
